import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./request/api"; // 导入api接口
import moment from "moment";
Vue.config.productionTip = false;
import "./assets/stylus/index.styl";
import { NavBar } from "vant";
import { RadioGroup, Radio } from "vant";
import { Cell, CellGroup } from "vant";
import { Field } from "vant";
import { Popup } from "vant";
import { CouponCell, CouponList } from "vant";
import { Toast } from 'vant';
import { CountDown } from 'vant';
import { Button } from 'vant';
import { Divider } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';
import { Image } from 'vant';
import { Icon } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Tab, Tabs } from 'vant';
import { NumberKeyboard } from 'vant';
import { Form } from 'vant';
import { Uploader } from 'vant';
Vue.use(Uploader);
Vue.use(Form);
Vue.use(NumberKeyboard);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cell).use(CellGroup);
Vue.use(Field);
Vue.use(Popup);
Vue.use(CouponCell).use(CouponList);
Vue.use(Toast);
Vue.use(CountDown);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Divider);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Image);
Vue.use(Lazyload);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

Vue.prototype.$api = api;
Vue.prototype.$toast = Toast;
Vue.prototype.$moment = moment;
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue() // 巴士
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
